import {derivePortalPlacement,portalPlacementPose} from './portal-placement.mjs';
/** Visual preview only. Never changes player/world/colliders; submit always forces fresh validation. */
export function createPortalPlacementPreview({derive=derivePortalPlacement,intervalMs=100}={}) {
 let last=null,worldRef=null,revision=null,nextAt=-Infinity;
 return {
  sample({world,player,yawOffset=0,width,height,players=[],now=performance.now(),force=false}={}) {
   if(force||!last||worldRef!==world||revision!==world?.revision||now>=nextAt||now<nextAt-intervalMs){
    last=derive(world,player,{yawOffset,width,height,checkReachable:true,preparedOnly:true,players});worldRef=world;revision=world?.revision;nextAt=now+intervalMs;
   }
   const current=portalPlacementPose(player,{yawOffset});
   return {...last,portal:last.portal?{...last.portal,...current}:null,...(player?.grounded===false?{valid:false,code:'PORTAL_SUPPORT_REQUIRED',reason:'Stand on a solid surface to place a doorway'}:{})};
  },
  clear(){last=null;worldRef=null;revision=null;nextAt=-Infinity;}
 };
}
